<!-- Header -->
<h3 mat-dialog-title
	translate>
	School Search
</h3>

<!-- Body -->
<mat-dialog-content>

	<div style="display: flex; flex-direction: row;">

		<!-- Select all buttons -->
		<div style="display: flex; flex-direction: column; justify-content: flex-start; padding-right: 20px;">
			<a *ngFor="let type of types"
                [ngStyle]="{
                    'color': viewOnly ? 'grey' : null,
                    'cursor': viewOnly ? null : 'pointer'
                }"
				(click)="selectAll(type)">
				Select all {{type}}
			</a>
		</div>

		<!-- Sites Table -->
		<mat-table [dataSource]="tableData" matSortDisableClear matSort matSortActive="SchoolName" matSortDirection="asc" multiTemplateDataRows
			style="flex-grow: 1">

			<ng-container matColumnDef="More">
				<mat-header-cell *matHeaderCellDef> More </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<span aria-label="Expand row for more details">
						<i [ngClass]="tableData.checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons" aria-hidden="true"></i>
					</span>
				</mat-cell>
			</ng-container>

			<!-- Selected Column -->
			<ng-container matColumnDef="Selected">
				<mat-header-cell *matHeaderCellDef>
					<tyl-checkbox (click)="$event.stopPropagation();$event.preventDefault(); checkAll()" [checked]="allSelected" [disabled]="viewOnly" id="chkSelectAll"></tyl-checkbox>
				</mat-header-cell>
				<mat-cell *matCellDef="let site; let i = index;">
					<!-- <tyl-checkbox (click)="$event.stopPropagation();$event.preventDefault(); schoolSelected(site)" [checked]="site.selected" [disabled]="viewOnly" id="siteSelected{{i}}"></tyl-checkbox> -->
					<tyl-checkbox [checked]="site.selected" [indeterminate]="site.checkIndeterminate"(click)="$event.stopPropagation();$event.preventDefault(); schoolSelected(site)"  [disabled]="viewOnly" id="siteSelected{{i}}"></tyl-checkbox>
					<!-- <tyl-checkbox [(checked)]="checkedAll" [indeterminate]="checkIndeterminate" (change)="checkAll()"></tyl-checkbox> -->
				</mat-cell>
			</ng-container>

			<!-- SchoolName Column -->
			<ng-container matColumnDef="SchoolName">
				<mat-header-cell *matHeaderCellDef mat-sort-header
					translate>
					School
				</mat-header-cell>
				<mat-cell *matCellDef="let site; let i = index;">
					{{site.SchoolName}}
				</mat-cell>
			</ng-container>

			<!-- SchoolType Column -->
			<ng-container matColumnDef="SchoolType">
				<mat-header-cell *matHeaderCellDef mat-sort-header
					translate>
					Type
				</mat-header-cell>
				<mat-cell *matCellDef="let site; let i = index;">
					{{site.SchoolType}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="expandedDetailGradeLevel">
				<mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length" style="width:100%;" class="mat-detail-card">
					<div style="display:flex; flex-direction: column;">
						<ng-container *ngFor="let gl of element.GradeLevels">
							<tyl-checkbox id='{{"chkGradeLevel" + element.Id + gl.Id}}' name='{{"chkGradeLevel" + element.Id + gl.Id}}' [(checked)]='gl.selected' (change)="gradeLevelSelected(element, gl)">{{gl.Description}}</tyl-checkbox>
						</ng-container>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="expandedDetailYear">
				<mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length" style="width:100%;" class="mat-detail-card">
					<div style="display:flex; flex-direction: column;">
						<ng-container *ngFor="let year of element.Years">
							<tyl-checkbox id='{{"chkYear" + year.SiteYearId}}' name='{{"chkYear" + element.SiteYearId}}' [(checked)]='year.selected' (change)="yearSelected(element,year)">{{year.Description}}</tyl-checkbox>
						</ng-container>
					</div>
				</mat-cell>
			</ng-container>

			<!-- Row Definitions -->
			<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
			<mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="DataRow{{i}}" [ngStyle]="{'border-bottom-width':tableData.checkExpanded(row) ? '0px' : '1px'}"
				style="padding:0px;overflow: hidden;" matRipple (click)="(includeGradeLevels || includeYears) && tableData.toggleExpanded(row)" (keydown)="(includeGradeLevels || includeYears) && tableData.rowKeyPress($event, row)">
			</mat-row>

			<mat-row *matRowDef="let row; columns: moreColumns" [@detailExpand]="tableData.checkExpanded(row) ? 'expanded' : 'collapsed'"
				style="overflow: hidden;" class="mat-detail-row">
			</mat-row>
		</mat-table>
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button [image]="viewOnly ? 'save disabled.png' : 'save.png'"
			label="Select"
            [disabled]="viewOnly"
			(clickEvent)="save()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>
